// extracted by mini-css-extract-plugin
module.exports = {"component":"module-lock-wrapper_component__R7N14","isLocked":"module-lock-wrapper_isLocked__1rnN2"};